export default [
  {
    icon: "icon-yoga",
    title: "Yoga",
    content:
      "Interactive online classes with expert trainers, in small batches for personalized attention",
  },
  {
    icon: "icon-nutrition",
    title: "Nutrition",
    content:
      "1-on-1 consultations with our clinical nutritionists, including diet plans",
  },
  {
    icon: "icon-in-app",
    title: "In-app Wellness Content",
    content:
      "Wide content library including meditation, breathwork, sleep stories, soundscapes & more",
  },
  {
    icon: "icon-health-tracking",
    title: "Health Tracking",
    content:
      "Monitor everyday habits of hydration, exercise, food intake & sleep",
  },
  {
    icon: "icon-headphone",
    title: "24*7 Coach Support",
    content: "Talk to our coaches whenever you need to!",
  },
  {
    icon: "icon-communities",
    title: "In-app Communities",
    content: "Join health goal or condition specific communities",
  },
];
